import React from 'react'
import Loader from "../../Simple/Loader";

function GlobalFilters(props) {
  const {
    limit,
    onLimitSelect,
    country,
    onCountrySelect,
  } = props

  return (
      <>
        <select
            value={limit}
            onChange={(e) => onLimitSelect(e)}
            className="form-control select-lg mb-3"
            style={{fontSize: '14px'}}
        >
          <option value="50">Show 50</option>
          <option value="100">Show 100</option>
          <option value="200">Show 200</option>
          <option value="500">Show 500</option>
          <option value="1000">Show 1000</option>
          <option value="2000">Show 2000</option>
          <option value="5000">Show 5000</option>
          <option value="10000">Show 10000</option>
          <option value="20000">Show 20000</option>
          <option value="50000">Show 50000</option>
        </select>
        <select
            value={country}
            onChange={(e) => onCountrySelect(e)}
            className="form-control select-lg mb-3"
            style={{fontSize: '14px', paddingRight: 0}}
        >
          <option value={''}>All</option>
          <option value="fin">FIN</option>
          <option value="swe">SWE</option>
        </select>
      </>)
}

export default GlobalFilters
